import React from "react";
import "../../App.css";
import Cards from "../Cards";

function Peone() {
  return (
    <>
      <div className="pe01">
        <img src="images/img-17.jpg" width="100%" height="auto" alt="" />
      </div>
      <Cards />
    </>
  );
}

export default Peone;
